import React, { useState } from "react";
import * as math from "mathjs";

let open = 0;
let close = 0;
let closed = false;

export default function Calculator() {
    const [ historyDisplay, setHistoryDisplay ] = useState("");
    const [ resultDisplay, setResultDisplay ] = useState("0");
    const [ expression, setExpression ] = useState("");
    const [ angle, setAngle ] = useState("deg");
    const [ angleDisplay, setAngleDisplay ] = useState("Deg");
    const [ angleStyle, setAngleStyle ] = useState("logic font13 deg");

    function display(value) {
        switch (value) {
            case angleDisplay:
                if (angleDisplay === "Deg") {
                    setAngleStyle("logic font13");
                    setAngleDisplay("Rad");
                    setAngle("rad");
                } else {
                    setAngleStyle("logic font13 deg");
                    setAngleDisplay("Deg");
                    setAngle("deg");
                }
                break;
            case 'sin':
                if (resultDisplay === "0") {
                    setResultDisplay(value + "(");
                    setExpression(value + "(" + angle + " ");
                } else {
                    setResultDisplay(resultDisplay + value + "(");
                    setExpression(expression + value + "(" + angle + " ");
                }
                open++;
                break;
            case 'cos':
                if (resultDisplay === "0") {
                    setResultDisplay(value + "(");
                    setExpression(value + "(" + angle + " ");
                } else {
                    setResultDisplay(resultDisplay + value + "(");
                    setExpression(expression + value + "(" + angle + " ");
                }
                open++;
                break;
            case 'tan':
                if (resultDisplay === "0") {
                    setResultDisplay(value + "(");
                    setExpression(value + "(" + angle + " ");
                } else {
                    setResultDisplay(resultDisplay + value + "(");
                    setExpression(expression + value + "(" + angle + " ");
                }
                open++;
                break;
            case 'EXP':
                if (resultDisplay === "0") {
                    setExpression("0*10^");
                } else {
                    setExpression(expression + "*10^");
                }
                setResultDisplay(resultDisplay + "E");
                break;
            case 'x!':
                if (resultDisplay === "0") {
                    setExpression("0!");
                } else {
                    setExpression(expression + "!");
                }
                setResultDisplay(resultDisplay + "!");
                break;
            case 'ln':
                if (resultDisplay === "0") {
                    setResultDisplay(value + "(");
                    setExpression(value + "( ");
                } else {
                    setResultDisplay(resultDisplay + value + "(");
                    setExpression(expression + value + "( ");
                }
                open++;
                break;
            case 'log':
                if (resultDisplay === "0") {
                    setResultDisplay(value + "(");
                    setExpression(value + "( ");
                } else {
                    setResultDisplay(resultDisplay + value + "(");
                    setExpression(expression + value + "( ");
                }
                open++;
                break;
            case '√':
                if (resultDisplay === "0") {
                    setResultDisplay(value + "(");
                    setExpression("sqrt( ");
                } else {
                    setResultDisplay(resultDisplay + value + "(");
                    setExpression(expression + "sqrt( ");
                }
                open++;
                break;
            case 'x<sup>y</sup>':
                if (resultDisplay === "0") {
                    setExpression("0^");
                } else {
                    setExpression(expression + "^");
                }
                setResultDisplay(resultDisplay + "^");
                break;
            case '(':
                if (resultDisplay === "0") {
                    setResultDisplay(value);
                    setExpression(value);
                } else {
                    setResultDisplay(resultDisplay + value);
                    setExpression(expression + value);
                }
                open++;
                break;
            case ')':
                if (resultDisplay === "0") {
                    
                } else {
                    setResultDisplay(resultDisplay + value);
                    setExpression(expression + value);
                }
                close++;
                break;
            case '%':
                if (resultDisplay === "0") {
                    setExpression("0%");
                } else {
                    setExpression(expression + value);
                }
                setResultDisplay(resultDisplay + value);
                break;
            default:
                if (value === "1" | value === "2" | value === "3" | value === "4" | value === "5" | value === "6" | value === "7" | value === "8" | value === "9" | value === "0" | value === ".") {
                    if (resultDisplay === "0") {
                        setResultDisplay(value);
                        setExpression(value);
                    } else {
                        setResultDisplay(resultDisplay + value);
                        setExpression(expression + value);
                    }
                }
                else if (value === "÷" | value === "×" | value === "-" | value === "+") {
                    setResultDisplay(resultDisplay + " " + value + " ");
                    if (resultDisplay === "0") {
                        setExpression("0");
                    }
                    if (value === "÷") {
                        setExpression(expression + "/");
                    } else if (value === "×") {
                        setExpression(expression + "*");
                    } else if (value === "-") {
                        setExpression(expression + "-");
                    } else if (value === "+") {
                        setExpression(expression + "+");
                    }
                }
                break;
        }
    }

    function clearScreen() {
        setResultDisplay("0");
        setExpression("");
    }

    function closeParentheses() {
        if (open === close) {
            closed = true;
        } else {
            closed = false;
        }

        if (closed === false) {
            for (let i = 0; i < (open - close); i++) {
                setResultDisplay(resultDisplay + ")");
                setExpression(expression + ")");
            }
        }
    }

    function calculate() {
        try {
            closeParentheses();
            let ans = math.evaluate(expression);
            setResultDisplay(ans);
            setExpression(ans);
            setHistoryDisplay(resultDisplay + " = ");
        } catch(error) {
            setResultDisplay("Error");
            setExpression("");
        }
    }

    return (
        <div className = "calculator-box">
            <div class = "display-box">
                <div class = "history">
                    <span id = "expression">{ historyDisplay }</span>
                </div>
                <div class = "result">
                    <span id = "display">{ resultDisplay }</span>
                </div>
            </div>
            <div class = "logic-box">
                <div class = "logic-row">
                    <div class = { angleStyle } id = "deg" onClick = {(e) => { display(e.target.innerText) }}>{ angleDisplay }</div>
                    <div class = "logic soloop font13" onClick = {(e) => { display(e.target.innerText) }}>x!</div>
                    <div class = "logic bracket" onClick = {(e) => { display(e.target.innerText) }}>(</div>
                    <div class = "logic bracket" onClick = {(e) => { display(e.target.innerText) }}>)</div>
                    <div class = "logic soloop" onClick = {(e) => { display(e.target.innerText) }}>%</div>
                    <div class = "logic font13" id = "clear" onClick = {(e) => { clearScreen() }}>AC</div>
                </div>
                <div class = "logic-row">
                    <div class = "logic function font13" onClick = {(e) => { display(e.target.innerText) }}>sin</div>
                    <div class = "logic function font13" onClick = {(e) => { display(e.target.innerText) }}>ln</div>
                    <div class = "logic number" onClick = {(e) => { display(e.target.innerText) }}>7</div>
                    <div class = "logic number" onClick = {(e) => { display(e.target.innerText) }}>8</div>
                    <div class = "logic number" onClick = {(e) => { display(e.target.innerText) }}>9</div>
                    <div class = "logic operator font18" onClick = {(e) => { display(e.target.innerText) }}>÷</div>
                </div>
                <div class = "logic-row">
                    <div class = "logic function font13" onClick = {(e) => { display(e.target.innerText) }}>cos</div>
                    <div class = "logic function font13" onClick = {(e) => { display(e.target.innerText) }}>log</div>
                    <div class = "logic number" onClick = {(e) => { display(e.target.innerText) }}>4</div>
                    <div class = "logic number" onClick = {(e) => { display(e.target.innerText) }}>5</div>
                    <div class = "logic number" onClick = {(e) => { display(e.target.innerText) }}>6</div>
                    <div class = "logic operator font18" onClick = {(e) => { display(e.target.innerText) }}>×</div>
                </div>
                <div class = "logic-row">
                    <div class = "logic function font13" onClick = {(e) => { display(e.target.innerText) }}>tan</div>
                    <div class = "logic function font13" onClick = {(e) => { display(e.target.innerText) }}>√</div>
                    <div class = "logic number" onClick = {(e) => { display(e.target.innerText) }}>1</div>
                    <div class = "logic number" onClick = {(e) => { display(e.target.innerText) }}>2</div>
                    <div class = "logic number" onClick = {(e) => { display(e.target.innerText) }}>3</div>
                    <div class = "logic operator font18" onClick = {(e) => { display(e.target.innerText) }}>-</div>
                </div>
                <div class = "logic-row">
                    <div class = "logic operator font13" onClick = {(e) => { display(e.target.innerText) }}>EXP</div>
                    <div class = "logic operator font13" onClick = {(e) => { display(e.target.innerHTML) }}>x<sup>y</sup></div>
                    <div class = "logic number" onClick = {(e) => { display(e.target.innerText) }}>0</div>
                    <div class = "logic number font18" onClick = {(e) => { display(e.target.innerText) }}>.</div>
                    <div class = "logic equal font18" id = "equal" onClick = {() => { calculate() }}>=</div>
                    <div class = "logic operator font18" onClick = {(e) => { display(e.target.innerText) }}>+</div>
                </div>
            </div>
        </div>
    );
}